<template>
    <div class="survey">
        <my-header></my-header>
        <el-row :span="24" class="bg-color">
            <!-- <el-col :span="4" ><div>&nbsp;</div></el-col> -->
            <el-col :span="20" :xs="{span:20,offset:2}" :sm="{span:20,offset:2}" :md="{span:20,offset:2}">
                <nav class="nav">
                    <ul>
                        <li v-for="(list,index) in navList"  :class="{ active:changeRed == index}"  :key="index" @click="active(index)">{{list.text}}</li>
                    </ul>
                </nav>
            </el-col>
            <!-- <el-col :span="4"><div>&nbsp;</div></el-col> -->
        </el-row>
        <el-row :span="24">
            <el-col :span="20" :xs="{span:20,offset:2}" :sm="{span:20,offset:2}" :md="{span:20,offset:2}">
                <div class="suery">
                    <div class="suery_item">
                        <span class="suery_title">发展历史</span>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中国在俄投资实体企业联合会是由在俄罗斯联邦进行实体投资的，拥有实体工厂，法人公司的中国公民个人，中国民间企业自发组织，成立的。联合会于2020年    月   日在俄罗斯联邦司法部  正式登记注册，并在中华人民共和国商务部，驻俄罗斯使馆登记，备案</p>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联合会采用自愿加入，共同参与管理的形式运营。在俄罗斯首都莫斯科市图拉大街10号设有常驻秘书处，负责接待会员。</p>
                    </div>
                    <div class="suery_item">
                        <span class="suery_title">指导思想</span>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在中俄全面战略合作伙伴关系基础之上，在中国政府”一带一路”合作发展倡议指引下，中国在俄投资实体企业联合会面向在俄罗斯联邦的投资人，企业提供对应服务。以互助互惠，信息交流为宗旨，团结、联合社会各界，沟通企业与政府、企业与企业、企业与社会间的联系，提高企业经营管理水平和企业竞争力，推进企业经营者素质建设，普及有关法律税务等知识，培养提高经营者遵纪守法意识，依法维护中国在俄罗斯投资经营的企业和企业家的合法权益等。</p>
                    </div>
                    <div class="suery_item">
                        <span class="suery_title">组织机构</span>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中国在俄投资实体企业联合会设秘书处，联络，沟通会员，处理联合会日常事务。</p>
                    </div>
                    <div class="suery_item">
                        <span class="suery_title">理事成员</span>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;聘请了中国企业界德高望众的知名人士——————————顾问，——————————————担任名誉会长，——————————同志任会长，——————————同志任常务副会长兼理事长。一大批国内著名的企业家分别担任副会长、常务理事、理事。</p>
                    </div>
                    <div class="suery_item">
                        <span class="suery_title">经费资产</span>
                        <span class="suery_msg">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;经费主要来源</span>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;一、按国家有关规定收取的会费</p>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;二、服务项目收入</p>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;三、国（境）内外团体、企业和个人的捐赠</p>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;四、受委托项目收入</p>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;五、其他合法收入</p>
                    </div>
                </div>
            </el-col>
        </el-row>
         
        <my-footer></my-footer>
    </div>
</template>

<script>
import MyHeader  from '../headerPage'
import MyFooter  from '../footerPage'
export default {
    components:{ MyHeader,MyFooter},
    data() {
        return {
            changeRed:1,
            navList:[{
                text:"首页"
            },{
                text:"简介概况"
            },{
                text:"会员中心"
            },{
                text:"联系我们"
            }],
        }
    },
    methods:{
        active(index){
            this.changeRed = index;
            if(index == 0){
                this.$router.push({name:"homePage"})
            }else if(index == 1){
                this.$router.push({name:"surveyPage"})
            }else if(index == 2){
                this.$router.push({name:"memberPage"})
            }else if(index == 3){
                this.$router.push({name:"aboutPage"})
            }
        },
    }
}
</script>

<style scoped >
    /* 导航 */
    .bg-color{
        background-color: #DBDBDB;
    }
    .nav{
        width:100%;
        height:auto;
        background-color: #DBDBDB;
    }
    .nav ul{
        height:40px;
        margin:0 auto;
        
    }
    .nav ul li {
        float:left;
        width:25%;
        box-sizing: border-box;
        padding:10px 10px;
        color:#5B5B5B;
        font-size:20px;
        font-weight:600;
        text-align: center;
        cursor:pointer;
    }
    .nav ul li.active{
        color:#fff;
        background-color: #1f3356;
    }
    .suery{
        width:100%;
        height:auto;
        min-height:800px;
        box-sizing: border-box;
        padding:20px 20px;
        background-color: #f8f8f8;
    }
    .suery_item p{
        margin-bottom:10px;
        font-size:22px;
        color:#666;
    }
    .suery_msg{
        display:block;
        color:#666;
        font-size:20px;
        margin-bottom:8px;
    }
    .suery_title{
        display:block;
        font-size:26px;
        font-weight:bold;
        color:#333;
        margin-bottom:6px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ZH-CN/jjgkPage.vue